import React, {Component} from 'react';
import PropTypes from "prop-types";

class ReportTile extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        image: PropTypes.object.isRequired,
        clickHandler: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

    };

    render() {

        let rptName = this.props.name;
        let title = this.props.title ? this.props.title : '';
        let description = this.props.description ? this.props.description : '';

        return (
            <div className={"modulcontainer withoutcaroussel col-xs-6"}>
                <div className={"reportsTile"} onClick={(e) => this.props.clickHandler(e, rptName)}>
                    <header>
                        <h2 data-i18n={rptName + 'Header'}>{title}</h2>
                    </header>

                    <section className={"diagrams cols"}>{this.props.image}</section>

                    <section className={"reportsTile-footer legend cols"}>
                        <p data-i18n={rptName + 'Description'}>{description}</p>
                    </section>
                </div>
            </div>
        );

    }

}

export default ReportTile;